import { SampleData } from "../../stores/Sample";
import { AlignmentOptions } from "../../stores/Search";
import { SampleAnchor, SampleQuote } from "../PaperShared/Sample";
import { SamplesList } from "../SamplesList";

function Sample1089200() {
  const samplesList: SampleData[] = similarSamples.map(
    (sample) =>
      new SampleData(
        sample.text,
        [...sample.text],
        sample.activations,
        sample.normalizedActivation,
        sample.targetIdx,
        sample.absoluteTokenIdx,
        sample.modelId
      )
  );

  return (
    <>
      <h4>
        <SampleAnchor modelId="baby-v1" sampleId="1089200" />
        <span> - </span>
        <SampleQuote text="The King of" targetIdx={9} />
      </h4>
      <p>
        For this example, the smaller 4-layer model produces a mediocre prediction that reflects the
        letter pattern found in words starting with the letter "o". Conversely, the 6-layer model
        predicts, with 94% certainty, the completion of the word “of”. A circuit extracted from the
        6-layer model includes features that, as a group, respond to the pattern “the … of”. With
        this pattern, the extracted “circuit” demonstrates enhanced confidence in a prediction
        despite the sequence “The King of” (note capitalization) not existing within the training
        dataset.
      </p>
      <figure>
        <figcaption>Samples Activating Common Features</figcaption>
        <SamplesList
          samples={samplesList}
          alignment={AlignmentOptions.Token}
          rightPadding={20}
          hideActivation={true}
          showIcon={true}
        />
      </figure>
    </>
  );
}

const similarSamples = [
  {
    text: "r snow\nBy thinking on fantastic summer's heat?\nO, no! the apprehension of the good\nGives but the greater feeling to the worse:\nFell sorrow's tooth doth never rankle more\nThan when he bites, but lanceth not the sore.\n\nJOHN OF GAUNT:\nCome, come, my son, I'll",
    activations: [
      0, 0, 0, 0.031, 0, 0, 0, 0, 0, 0, 0, 0, 0.037, 0, 0, 0, 0, 0, 0, 0.148, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0.032, 0, 0, 0.034, 0, 0.046, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0.033, 0, 0, 0, 0, 0, 0, 0, 0, 0.517, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.036, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.086, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.036, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0.03, 0.036, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.027, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.036, 0, 0.038, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.042, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    normalizedActivation: [
      0, 0, 0, 0.059845559845559844, 0, 0, 0, 0, 0, 0, 0, 0, 0.07142857142857142, 0, 0, 0, 0, 0, 0,
      0.2857142857142857, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.06177606177606178, 0, 0,
      0.06563706563706564, 0, 0.08880308880308879, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0.0637065637065637, 0, 0, 0, 0, 0, 0, 0, 0, 0.9980694980694981, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0.06949806949806948, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0.166023166023166, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.06949806949806948, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.05791505791505791, 0.06949806949806948, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.052123552123552123, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0.06949806949806948, 0, 0.07335907335907335, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0.08108108108108109, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    targetIdx: 71,
    absoluteTokenIdx: 343111,
    modelId: "baby",
  },
  {
    text: "d friends, mine honest neighbours,\nWill you undo yourselves?\n\nFirst Citizen:\nWe cannot, sir, we are undone already.\n\nMENENIUS:\nI tell you, friends, most charitable care\nHave the patricians of you. For your wants,\nYour suffering in this dearth, you may as w",
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.044,
      0, 0, 0, 0, 0, 0.039, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.034,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.039, 0, 0, 0.043, 0, 0, 0.04, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.058, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.049, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.034,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.513, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0.033, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.033, 0, 0, 0.031, 0, 0, 0, 0, 0, 0,
      0.048, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    normalizedActivation: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.08494208494208494, 0, 0, 0, 0, 0, 0.07528957528957529, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.06563706563706564, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.07528957528957529, 0, 0, 0.083011583011583, 0, 0, 0.07722007722007722, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.11196911196911197, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.0945945945945946, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.06563706563706564, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.9903474903474904, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.0637065637065637, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.0637065637065637, 0, 0,
      0.059845559845559844, 0, 0, 0, 0, 0, 0, 0.09266409266409266, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    targetIdx: 189,
    absoluteTokenIdx: 2749,
    modelId: "baby",
  },
  {
    text: "your royal self\nThis proffer'd benefit of dignity;\nIf non to bless us and the land withal,\nYet to draw forth your noble ancestry\nFrom the corruption of abusing times,\nUnto a lineal true-derived course.\n\nLord Mayor:\nDo, good my lord, your citizens entreat y",
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0.035, 0, 0.202, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.102, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.037, 0.051, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0.066, 0, 0, 0.04, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0.489, 0, 0, 0, 0, 0.033, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.042, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0.038, 0, 0, 0, 0.035, 0, 0.091, 0, 0.051, 0, 0, 0, 0, 0, 0,
    ],
    normalizedActivation: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0.06756756756756757, 0, 0.38996138996138996, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0.1969111969111969, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.07142857142857142, 0.09845559845559845, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.1274131274131274, 0, 0, 0.07722007722007722, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.944015444015444, 0, 0, 0, 0, 0.0637065637065637, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0.08108108108108109, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.07335907335907335, 0, 0, 0, 0.06756756756756757, 0, 0.17567567567567566, 0,
      0.09845559845559845, 0, 0, 0, 0, 0, 0,
    ],
    targetIdx: 149,
    absoluteTokenIdx: 257941,
    modelId: "baby",
  },
  {
    text: "ean to save him, but that either\nYou must lay down the treasures of your body\nTo this supposed, or else to let him suffer;\nWhat would you do?\n\nISABELLA:\nAs much for my poor brother as myself:\nThat is, were I under the terms of death,\nThe impression of keen",
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.032, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0.353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0.035, 0, 0, 0, 0.059, 0, 0, 0, 0, 0.033, 0.031, 0, 0, 0, 0, 0, 0, 0.039, 0.093, 0, 0, 0,
      0, 0, 0, 0.041, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.123, 0, 0.044, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0.044, 0, 0, 0, 0, 0.079, 0, 0, 0, 0, 0, 0, 0.049, 0, 0, 0, 0, 0, 0, 0, 0, 0.07, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.302, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.037, 0, 0, 0, 0, 0, 0, 0, 0, 0.447, 0, 0, 0, 0, 0, 0,
    ],
    normalizedActivation: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.06177606177606178, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.6814671814671814, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.06756756756756757, 0, 0, 0, 0.1138996138996139, 0, 0, 0, 0,
      0.0637065637065637, 0.059845559845559844, 0, 0, 0, 0, 0, 0, 0.07528957528957529,
      0.17953667953667954, 0, 0, 0, 0, 0, 0, 0.07915057915057915, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0.23745173745173745, 0, 0.08494208494208494, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.08494208494208494, 0, 0, 0, 0, 0.1525096525096525, 0, 0, 0, 0, 0, 0, 0.0945945945945946, 0,
      0, 0, 0, 0, 0, 0, 0, 0.13513513513513514, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.583011583011583, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.07142857142857142, 0, 0, 0, 0, 0, 0, 0, 0, 0.8629343629343629, 0, 0, 0, 0, 0, 0,
    ],
    targetIdx: 249,
    absoluteTokenIdx: 890873,
    modelId: "baby",
  },
  {
    text: "ng, Marcius is proud;\nwho in a cheap estimation, is worth predecessors\nsince Deucalion, though peradventure some of the\nbest of 'em were hereditary hangmen. God-den to\nyour worships: more of your conversation would\ninfect my brain, being the herdsmen of th",
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.043, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.042, 0, 0, 0, 0, 0, 0.035, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.039, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0.097, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.039, 0, 0, 0, 0, 0, 0, 0, 0.127, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0.037, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.035, 0, 0, 0.037, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.037, 0, 0, 0, 0, 0, 0.41, 0, 0, 0, 0,
    ],
    normalizedActivation: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.083011583011583, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.08108108108108109, 0,
      0, 0, 0, 0, 0.06756756756756757, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.07528957528957529, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.18725868725868725, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.07528957528957529, 0, 0, 0, 0, 0, 0, 0, 0.24517374517374518, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.07142857142857142, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0.06756756756756757, 0, 0, 0.07142857142857142, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0.07142857142857142, 0, 0, 0, 0, 0, 0.7915057915057915, 0, 0, 0, 0,
    ],
    targetIdx: 251,
    absoluteTokenIdx: 39419,
    modelId: "baby",
  },
  {
    text: "ould not\nhave relished among my other discredits.\nHere come those I have done good to against my will,\nand already appearing in the blossoms of their fortune.\n\nShepherd:\nCome, boy; I am past moe children, but thy sons and\ndaughters will be all gentlemen bo",
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.04, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.06, 0, 0, 0, 0, 0,
      0, 0, 0, 0.067, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.053, 0, 0, 0, 0, 0, 0, 0, 0,
      0.076, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.036, 0, 0.032, 0,
      0, 0, 0, 0, 0.04, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.055, 0.037, 0, 0, 0, 0, 0, 0, 0, 0.071, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0.395, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.043, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0.034, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.072, 0, 0,
      0, 0, 0, 0, 0, 0.035, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.081, 0, 0, 0, 0.051, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.077, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0,
    ],
    normalizedActivation: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.07722007722007722, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.11583011583011582, 0, 0, 0, 0, 0, 0, 0, 0, 0.12934362934362933, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0.1023166023166023, 0, 0, 0, 0, 0, 0, 0, 0, 0.1467181467181467, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.06949806949806948, 0,
      0.06177606177606178, 0, 0, 0, 0, 0, 0.07722007722007722, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.10617760617760617, 0.07142857142857142, 0, 0, 0, 0, 0, 0, 0, 0.13706563706563704, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.7625482625482626, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.083011583011583, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.06563706563706564, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.13899613899613897, 0, 0, 0, 0, 0, 0, 0, 0.06756756756756757, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.15637065637065636, 0, 0, 0, 0.09845559845559845, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.14864864864864863, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0,
    ],
    targetIdx: 141,
    absoluteTokenIdx: 836749,
    modelId: "baby",
  },
];

export { Sample1089200 };
